
import 'bootstrap';
import $ from 'jquery';
import 'slick-carousel';
import { mountComponent } from '@/lib/mount-component';
import { ResponseWheel } from './components/response-wheel';
import { ContactFormWrapper } from './components/contact-form';
import { HowToHelpWrapper } from './components/how-to-help/how-to-help';
import { OurImpactWrapper } from './components/our-impact';

mountComponent('#response-wheel', ResponseWheel);
mountComponent('#our-impact', OurImpactWrapper);
mountComponent('#how-to-help', HowToHelpWrapper);
mountComponent('#contact-form', ContactFormWrapper);

$(document).ready(() => {

    $('.slider').slick({
        dots: false,
        slidesToShow: 2,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.slider-full').slick({
        dots: false,
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
});
